'use strict';
var account = require('../account');


// can be used not only for Locale but for other cookie values as well
function getCookieByName(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    if (match) return match[2];
}

const currentLocale = getCookieByName('preferredLocale');

function replaceUrl() {
	var currentCountry = '';
	if(window.GlobalAttributes !== undefined && window.GlobalAttributes.COUNTRY !== undefined) {
		currentCountry = window.GlobalAttributes.COUNTRY.toLowerCase();
		if(currentCountry != '' && currentCountry != 'ae') {
			currentCountry = currentCountry+'/';
		} else {
			currentCountry = '';
		}
	} 
    window.history.pushState(null, '', '/'+ currentCountry + currentLocale + '/' + 'order-confirmation');
}

function orderConfirmationGAEvents() {
	var user = dataLayer.find(o => o.user != null).user;
    $('.order-confirmation--content').find('.view-order-details').on('click', function (e) {
    	dataLayer.push({
    	    'event': 'custom_event',
    	    'eventCategory': 'thank_you_page',
    	   'eventAction': 'thank_you_view_order_click',
    	    'eventLabel': 'thank you view order click',
    	    'country': window.GlobalAttributes.COUNTRY,
    	    'language': window.GlobalAttributes.LANGUAGE,
    	    'screenName' : 'Thank you screen',
    	    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
    	    'userId': user.user_id != '' ? user.user_id : ''
    	});
    })
    $('.order-confirmation--content').find('.continue-btn').on('click', function (e) {
    	dataLayer.push({
    	    'event': 'custom_event',
    	    'eventCategory': 'thank_you_page',
    	    'eventAction': 'thank_you_shop_now_click',
    	    'eventLabel': 'thank you shop now click',
    	    'country': window.GlobalAttributes.COUNTRY,
    	    'language': window.GlobalAttributes.LANGUAGE,
    	    'screenName' : 'Thank you screen',
    	    'userType': user.user_id != '' ? 'logged-in' : 'logged-out',
    	    'userId': user.user_id != '' ? user.user_id : ''
    	});
    })
}

exports.init = function () {
    replaceUrl();
	account.customerInterestsOnChangeEvent();
	orderConfirmationGAEvents();
};



// WEBPACK FOOTER //
// ./cartridges/app_modist_core/cartridge/js/pages/checkout/orderconfirmation.js